export default class AchievementBaseService {}
